// src/pages/CommissionCarrierPage.js
import React, { useEffect, useState } from 'react';
import {
  getCarriers,
  getCarrierCommissionPrices,
  setCarrierCommissionPrice
} from '../api';
import { Table, Button, Modal, Form, Spinner } from 'react-bootstrap';
import { isPropietarioOrAdminOrGestion, getCarrierId } from '../services/AuthService';

const CommissionCarrierPage = () => {
  const isAdmin = isPropietarioOrAdminOrGestion();
  const [carriers, setCarriers] = useState([]);
  // Si no es admin, preseleccionamos su carrierId y ocultamos el dropdown
  const [selectedCarrierId, setSelectedCarrierId] = useState(
    isAdmin
      ? ''
      : (getCarrierId()?.toString() || '')
  );
  const [prices, setPrices] = useState([]);
  const [loading, setLoading] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [editing, setEditing] = useState(null); // { id, commissionId, price, commissionName }

  // Cargamos la lista de transportistas solo si es admin
  useEffect(() => {
    if (isAdmin) {
      getCarriers()
        .then(setCarriers)
        .catch(console.error);
    }
  }, [isAdmin]);

  // Cuando cambie el transportista (o al montar si no es admin), cargamos precios
  useEffect(() => {
    if (!selectedCarrierId) {
      setPrices([]);
      return;
    }
    setLoading(true);
    getCarrierCommissionPrices(selectedCarrierId)
      .then(data => setPrices(data || []))
      .catch(err => {
        console.error(err);
        setPrices([]);
      })
      .finally(() => setLoading(false));
  }, [selectedCarrierId]);

  const openEdit = row => {
    setEditing({
      id: row.id,
      commissionId: row.carrierCommissionsId,
      price: row.price,
      commissionName: row.commission.name
    });
    setShowModal(true);
  };
  const closeModal = () => {
    setShowModal(false);
    setEditing(null);
  };

  const handleSave = async () => {
    try {
      await setCarrierCommissionPrice(selectedCarrierId, {
        carrierCommissionsId: editing.commissionId,
        price: Number(editing.price),
        carrierId: selectedCarrierId,
        id: editing.id
      });
      const updated = await getCarrierCommissionPrices(selectedCarrierId);
      setPrices(updated || []);
      closeModal();
    } catch (err) {
      console.error(err);
      alert('Error al guardar el precio');
    }
  };

  return (
    <div className="container my-4">
      <h2 className="mb-4">Tarifas de transportista</h2>

      {isAdmin && (
        <Form.Group className="mb-3" style={{ maxWidth: 300 }}>
          <Form.Label>Transportista</Form.Label>
          <Form.Select
            value={selectedCarrierId}
            onChange={e => setSelectedCarrierId(e.target.value)}
          >
            <option value="">Seleccionar transportista</option>
            {carriers.map(c => (
              <option key={c.id} value={c.id}>
                {c.firstName} {c.lastName1}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
      )}

      {loading ? (
        <Spinner animation="border" />
      ) : (
        selectedCarrierId && (
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>Descripción</th>
                <th>Comisión (€)</th>
                {isAdmin && <th>Acciones</th>}
              </tr>
            </thead>
            <tbody>
              {prices.map(row => (
                <tr key={row.commissionId}>
                  <td>{row.commission.name}</td>
                  <td>{row.price.toFixed(2)}</td>
                  {isAdmin && (
                    <td>
                      <Button size="sm" onClick={() => openEdit(row)}>
                        Editar
                      </Button>
                    </td>
                  )}
                </tr>
              ))}
              {prices.length === 0 && (
                <tr>
                  <td colSpan={isAdmin ? 3 : 2} className="text-center text-muted">
                    Sin datos
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        )
      )}

      <Modal show={showModal} onHide={closeModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Editar Precio de {editing?.commissionName}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Precio (€)</Form.Label>
            <Form.Control
              type="number"
              step="0.01"
              value={editing?.price}
              onChange={e =>
                setEditing(cur => ({ ...cur, price: e.target.value }))
              }
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeModal}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleSave}>
            Guardar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CommissionCarrierPage;
